import styled from "styled-components";
import { MediaQueries } from "ratel-ui";

import Icon from "../../components/icon";
import Tabbable from "../../components/tabbable";

export const Container = styled.div``;

export const Card = styled.div`
  position: relative;
  width: 641px;
  height: 540px;
  overflow: hidden;
  background: #000C29;
  border: 3px solid #ED7B22;
  border-radius: 16px;

  @media (max-width: 719px) {
    width: 344px;
    height: 485px;
  }
`;

export const Background = styled.div``;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  text-align: center;
  border: none;
  background-color: transparent;
`;

export const Asset = styled.div`
  height: 110px;
  width: 230px;
  background: url("/assets/logo_craques_enem.png");
  background-size: 210px 95px;
  background-repeat: no-repeat;
  margin: 25px 0 15px 0;

  @media (max-width: 719px) {
    margin: 24px 0 25px 0;
  }
`;

export const Title = styled.span`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;

  @media (max-width: 719px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const Text = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  max-width: 382px;
  margin: 8px 0 16px 0;

  @media (max-width: 720px) {
    font-size: 14px;
    line-height: 19px;
    max-width: 312px;
  }
`;

export const Close = styled(Tabbable)`
  display: flex;
  position: absolute;
  right: 24px;
  top: 24px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.15);
`;

export const CloseIcon = styled(Icon)`
  margin: auto;
  fill: ${(props) => props.theme.colors.clear};
`;

export const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: auto;
  padding: 0px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Input = styled.input`
  width: 513px;
  height: 46px;
  background: #ffffff;
  border: 2px solid #0E8030;
  margin: 8px 0;
  padding: 0 16px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  border-radius: 12px;

  &::placeholder {
    font-family: "Nunito";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #0b1943;
  }

  @media (max-width: 719px) {
    width: 312px;
    max-width: 312px;
    height: 43px;
    font-size: 14px;
    line-height: 19px;

    &::placeholder {
      font-size: 14px;
      line-height: 19px;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0px;
  border-radius: 0 0 16px 16px;
`;

export const Button = styled.button`
  width: 513px;
  height: 46px;
  background: #ED7B22;
  color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: none;
  margin-top: 16px;
  cursor: pointer;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  text-transform: uppercase;
  border-radius: 12px;

  @media (max-width: 719px) {
    width: 312px;
    height: 43px;
    font-size: 14px;
    line-height: 19px;
  }
`;

export const Form = styled.form`
  padding: 0;
`;

export const FormContainer = styled.div``;
